import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20cinematic%20composition%20with%20flowing%20warm%20gradients%20of%20deep%20coral%20and%20amber%20tones%2C%20soft%20geometric%20shapes%20floating%2C%20dreamy%20atmospheric%20texture%2C%20modern%20streaming%20platform%20aesthetic%2C%20elegant%20and%20sophisticated%20background%20for%20video%20platform&width=1800&height=800&seq=hero-bg-main&orientation=landscape"
        alt="黄瓜视频在线观看"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="relative z-10 text-center px-4 w-full max-w-3xl mx-auto">
        <h1 className="text-3xl md:text-5xl font-heading text-background-50 mb-4 animate-fade-in-up">
          {t('hero.title')}
        </h1>
        <p className="text-base md:text-lg text-background-50/80 mb-8 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
          {t('hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          <div className="relative w-full sm:w-96">
            <input
              type="text"
              placeholder={t('hero.search')}
              className="w-full px-5 py-3.5 rounded-full bg-background-50/95 text-foreground-800 text-sm placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
            />
            <button className="absolute right-1.5 top-1/2 -translate-y-1/2 px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              <div className="flex items-center gap-1.5">
                <i className="ri-search-line"></i>
                <span>{t('hero.cta')}</span>
              </div>
            </button>
          </div>
        </div>
        <div className="flex items-center justify-center gap-8 md:gap-12 mt-8 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading text-accent-400">5000万+</div>
            <div className="text-xs md:text-sm text-background-50/70 mt-1">{t('hero.stats.users')}</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading text-accent-400">10万+</div>
            <div className="text-xs md:text-sm text-background-50/70 mt-1">{t('hero.stats.videos')}</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading text-accent-400">8</div>
            <div className="text-xs md:text-sm text-background-50/70 mt-1">{t('hero.stats.categories')}</div>
          </div>
        </div>
      </div>
    </section>
  );
}